import React from "react"
import styled from "styled-components"
import { theme } from "@/containers/LuckyBagNew2023/Views/mixin"
import NextImg from "@/common/components/NextImg/index"
// images
import NFTBOX from "@/common/assets/image/lucky-bag-2023/decorationsNew/NFTBOX.webp"
import starMask from "@/common/assets/image/lucky-bag-2023/decorationsNew/starMask.svg"
// import Q1 from "@/common/assets/image/lucky-bag-2023/decorationsNew/Q1.svg"
// import Q2 from "@/common/assets/image/lucky-bag-2023/decorationsNew/Q2.svg"
// import rewards from "@/common/assets/image/lucky-bag-2023/decorationsNew/iphone.webp"
import iphone from "@/common/assets/image/lucky-bag-2023/bonus/iphone.webp"
import ps5 from "@/common/assets/image/lucky-bag-2023/bonus/ps5.webp"
import ipad from "@/common/assets/image/lucky-bag-2023/bonus/ipad.webp"
import watch from "@/common/assets/image/lucky-bag-2023/bonus/watch.webp"
import tv from "@/common/assets/image/lucky-bag-2023/bonus/tv.webp"
import airpods from "@/common/assets/image/lucky-bag-2023/bonus/airpods.webp"

export default function NFTBox() {
  return (
    <HeroWrapper>
      <NFTboxWrapper>
        <NextImg src={NFTBOX} />
      </NFTboxWrapper>
      <BGWrapper>
        <BGColor></BGColor>
      </BGWrapper>
      <HeroBGWrapper>
        <NextImg src={starMask} />
      </HeroBGWrapper>
      <IphoneWrapper>
        <NextImg src={iphone} />
      </IphoneWrapper>
      <IpadWrapper>
        <NextImg src={ipad} />
      </IpadWrapper>
      <WatchWrapper>
        <NextImg src={watch} />
      </WatchWrapper>
      <PS5Wrapper>
        <NextImg src={ps5} />
      </PS5Wrapper>
      <TVWrapper>
        <NextImg src={tv} />
      </TVWrapper>
      <AirpodsWrapper>
        <NextImg src={airpods} />
      </AirpodsWrapper>
    </HeroWrapper>
  )
}

const HeroWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`
const NFTboxWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  z-index: 3;
  span {
    animation: updown 8s infinite;
  }
`

const HeroBGWrapper = styled.div`
  width: 100%;
  animation: spin 30s infinite linear;
`
const BGWrapper = styled.div`
  position: absolute;
  width: 98%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`
const BGColor = styled.div`
  background-image: ${theme.StrongBgLinearTop};
  width: 100%;
  padding-bottom: 100%;
  border-radius: 50%;
`

const IphoneWrapper = styled.div`
  position: absolute;
  width: 30%;
  bottom: 0%;
  left: 0%;
  animation: Appear 15s infinite 1s;
  z-index: 333;
`
const IpadWrapper = styled.div`
  position: absolute;
  width: 28%;
  top: 0%;
  left: -3%;
  animation: Appear 10s infinite 3s;
`
const PS5Wrapper = styled.div`
  position: absolute;
  z-index: 333;
  width: 30%;
  bottom: 5%;
  right: 0%;
  animation: Appear 12s infinite 2s;
`
const TVWrapper = styled.div`
  position: absolute;
  width: 25%;
  top: 0%;
  right: -5%;
  animation: Appear 8s infinite 6s;
`
const WatchWrapper = styled.div`
  position: absolute;
  width: 23%;
  top: 40%;
  left: -10%;
  animation: Appear 12s infinite 8s;
`
const AirpodsWrapper = styled.div`
  position: absolute;
  width: 18%;
  top: 40%;
  right: -10%;
  animation: Appear 8s infinite 4s;
`

// const Q2Wrapper = styled.div`
//   position: absolute;
//   width: 15%;
//   top: 4%;
//   left: 5%;
//   animation: updown 8s infinite;
// `
// const Q1Wrapper = styled.div`
//   position: absolute;
//   width: 18%;
//   top: 15%;
//   right: 0%;
//   animation: updown 8s infinite 4s;
// `
// const RewardWrapper = styled.div`
//   position: absolute;
//   width: 30%;
//   z-index: 4;
//   bottom: 12%;
//   right: 4%;
//   box-shadow: 1px 8px 12px rgba(0, 0, 0, 0.088);
//   border-radius: 50%;
//   animation: updown 30s infinite;
// `
